export var ENVIRONMENT = /*#__PURE__*/ function(ENVIRONMENT) {
    ENVIRONMENT["local"] = "local";
    ENVIRONMENT["dev"] = "dev";
    ENVIRONMENT["stg"] = "stg";
    ENVIRONMENT["production"] = "production";
    ENVIRONMENT["hipaa"] = "hipaa";
    return ENVIRONMENT;
}({});

//# sourceMappingURL=EnvironmentType.js.map